export default class InvalidCredentialsException extends Error {
	
}